import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import { ToggleBarChart, DonutBreakdownCard } from '../../../common/analytics';
import { VOLUME_COUNT_TOGGLES, DAILY_WEEKLY_TOGGLES } from '../../dashboard.constants';
import CardSkeleton from '../../../common/cardSkeleton/CardSkeleton';
import styles from './styles/direct-deposit-acquisition-section.module.scss';

function DirectDepositAcquisitionSection({ ddAcquisition, directDeposits, loading = false }) {
    return (
        <section className={styles.section}>
            <Text as="span" size="xs" className={styles.sectionLabel}>Direct Deposit Acquisition</Text>

            {loading ? (
                <div className={styles.splitRow}>
                    <CardSkeleton minHeight={420} rows={6} />
                    <CardSkeleton minHeight={420} rows={6} />
                </div>
            ) : (
            <div className={styles.splitRow}>
                <DonutBreakdownCard
                    title={ddAcquisition.title}
                    subtitle={ddAcquisition.subtitle}
                    total={ddAcquisition.total}
                    totalLabel={ddAcquisition.totalLabel}
                    segments={ddAcquisition.segments}
                />
                <ToggleBarChart
                    title={directDeposits.title}
                    subtitle={directDeposits.subtitle}
                    toggles={VOLUME_COUNT_TOGGLES}
                    defaultToggle="volume"
                    secondaryToggles={DAILY_WEEKLY_TOGGLES}
                    defaultSecondaryToggle="daily"
                    series={directDeposits.series}
                    data={directDeposits.data}
                    showLegend={false}
                />
            </div>
            )}
        </section>
    );
}

export default DirectDepositAcquisitionSection;
